<template>
  <div class="dashboard-wrap">
    <el-row :gutter="20">
      <el-col v-show="topSearch == true" class="block" :sm="24" :lg="24">
        <el-card shadow="hover" class="pie-wrap">
          <div style='margin-bottom:30px;'>
            <el-col :span="9">
              <div >
                <span class="demonstration">统计时间: </span>
                <el-date-picker
                :clearable="false"
                  style='width:260px'
                  size='mini'
                  v-model="ruleForm.date"
                  value-format="timestamp"
                  type="daterange"
                  placeholder="选择日期范围">
                </el-date-picker>
              </div>
            </el-col>
            <el-col  :span="6">油卡号:
              <el-input style='width:165px' size = 'mini' v-model="ruleForm.cardNumber" placeholder="请输入油卡号"></el-input>
            </el-col>
            <el-col  :span="5">车牌号:
              <el-input style='width:120px' size = 'mini' v-model="ruleForm.carNumber" placeholder="请输入车牌号"></el-input>
            </el-col>
            <el-col  :span="2">
              <el-button @click="submitForm('ruleForm')" size="mini" type='primary'>查询</el-button>
            </el-col>
             <el-col  :span="2">
              <el-button v-show="hideExport" @click="exportExcel" size="mini" type='primary'>导出</el-button>
            </el-col>
          </div>
        </el-card>
      </el-col> 
      <el-col :sm="24" :lg="24">
        <el-card shadow="hover" :class="topSearch == false?'pie-wrap search ': 'pie-wrap'" >
          <div>
            <template>
              <el-table
                v-show="topSearch ==true"
                :data="tableData"
                border
                  :height="height"
                style="width: 100%">
                <el-table-column
                  fixed
                  label="序号"
                  type="index"
                  width="50">
                </el-table-column>
                <el-table-column
                  prop="cardno"
                  label="卡号"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="vehicleNo"
                  label="绑定车牌号"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="cardTypeWord"
                  label="卡性质"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="userName"
                  label="持卡人"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="companyName"
                  label="企业名称"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="oiltypeWord"
                  label="油品异常"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="oilCountAbnormalWord"
                  label="加油次数异常"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="litterAbnormalWord"
                  label="加油量异常"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="nodeno"
                  label="消费油站编码"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="nodetag"
                  label="消费油站名称"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="provName"
                  label="发卡省"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="areaName"
                  label="发卡市"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="cardSiteNo"
                  label="发卡网点编号"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="cardSiteName"
                  label="发卡网点名称"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="litter"
                  label="消费升数（升）"
                  width="120">
                  <template slot-scope="scope">
                    {{format(scope.row.litter)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="amount"
                  label="消费金额（元）"
                  width="120">
                  <template slot-scope="scope">
                    {{format(scope.row.amount)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="opetime"
                  label="消费时间"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="oilno"
                  label="油品编码"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="oilname"
                  label="油品名称"
                  width="120">
                </el-table-column>
                 <el-table-column
                  prop="routeMatch"
                  label="轨迹是否匹配"
                  width="120">
                     <template slot-scope="scope">
                        <template v-if="scope.row.routeMatch==1">正常</template>
                        <template v-if="scope.row.routeMatch==2">异常</template>
                        <template v-if="scope.row.routeMatch==3||scope.row.routeMatch==4">未知</template>
                    </template>
                </el-table-column>
              </el-table>
              <el-form v-show="topSearch ==false" :rules="rules" class="form" ref="ruleForm" label-position="left" label-width="80px" :model="ruleForm">
                <el-form-item label="统计时间">
                  <div >
                    <el-date-picker
                    :clearable="false"
                      style='width:260px'
                      size='mini'
                      v-model="ruleForm.date"
                      value-format="timestamp"
                      type="daterange"
                      placeholder="选择日期范围">
                    </el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="油卡号" prop="cardNumber">
                  <el-input size="mini" style='width:250px' v-model="ruleForm.cardNumber"></el-input>
                </el-form-item>
                <el-form-item label="车牌号" prop="carNumber">
                  <el-input size="mini" style='width:250px' v-model="ruleForm.carNumber"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitForm('ruleForm')">查询异常卡</el-button>
                </el-form-item>
              </el-form>
            </template>
          </div>
        </el-card>
      </el-col>
      <el-col v-show="topSearch == true" class="block" :sm="24" :lg="24">
        <div class='pagination'>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="ruleForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalPages">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { randomIntegerInRange,hideExport } from '@/utils/tools'
// import { loginbyUser } from '@/api/singleCard'
import moment from 'moment'

export default {
  name: 'dashboard',
  components: {
  },
  data() {
    return {
       hideExport:hideExport,
       height: 300,
      totalPages:null,
      currentPage4: 1,
      ruleForm:{
        date:[new Date(new Date() * 1 - 30 * 24 * 3600 * 1000) * 1,
        new Date(new Date() * 1 - 1 * 24 * 3600 * 1000) * 1],
        cardNumber:'',
        carNumber:'',
        page:1,
        pageSize:10

      },
      topSearch:false,
      options: [{
          value: '0',
          label: '油品异常'
        }, {
          value: '1',
          label: '加油量异常'
        }, {
          value: '2',
          label: '加油次数异常'
        }],
      // pieLegendData: chartData.fpsLegend,
      tableData: [],
      rules: {
         cardNumber: [
           { min: 10, message: '油卡号至少10位数字', trigger: 'blur' }
         ],
         carNumber: [
           { min: 4, message: '车牌号至少4位字符', trigger: 'blur' }
         ],
      }
    }
  },
  watch: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  created(){
    this.height=window.innerHeight-350;
    window.onresize=()=>{
      this.height=window.innerHeight-350;
    }
  },
  methods: {
    format(num) {
      var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
          return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
              return $1+",";
            });
      })
      return res;
    },
    handleSezarch(){
      let that = this
      let start = that.ruleForm.date?new Date(that.ruleForm.date[0]).getTime():''
      let end = that.ruleForm.date?new Date(that.ruleForm.date[1]).getTime():''
      let cardNumber = that.ruleForm.cardNumber
      let carNumber= that.ruleForm.carNumber
    },
    submitForm(form){

      if(this.ruleForm.cardNumber == '' && this.ruleForm.carNumber == ''){
        this.$message({
            message: '油卡号和车牌号至少一个不为空',
            type: 'error',
            duration: 1000,
            showClose: true
          })
          return ;
      }
      this.$refs[form].validate(async valid => {
        if (valid) {
          try{
            let data = {}
            let syncTimeStart   = this.ruleForm.date?new Date(this.ruleForm.date[0]).getTime():''
            let syncTimeEnd   = this.ruleForm.date?new Date(this.ruleForm.date[1]).getTime():''
            let cardNo  = this.ruleForm.cardNumber ||''
            let vehicleNo= this.ruleForm.carNumber ||''
            let page= 1
            let pageSize= this.ruleForm.pageSize

            const response = await this.$store.dispatch('getSingleCardData', { syncTimeStart,syncTimeEnd,cardNo,vehicleNo,page,pageSize })
              if(response.code == 200){
                this.tableData = response.data.list
                this.totalPages = response.data.count
                response.data&&response.data.list&&response.data.list.map((ele,index)=>{
                 if(ele.cardType == 1){
                  ele.cardTypeWord = '主卡'
                }else if(ele.cardType == 2){
                  ele.cardTypeWord = '副卡'
                }else if(ele.cardType == 0){
                  ele.cardTypeWord = '单卡'
                }
                  // ele.routeMatch==1? ele.routeMatchWord ='是' : ele.routeMatch==2 ? ele.routeMatchWord ='否' :ele.routeMatch==3? ele.routeMatchWord ='未知' : ele.routeMatchWord ='-'
                  ele.opetime?ele.opetime = moment(ele.opetime).format('YYYY-MM-DD HH:mm:ss'):ele.opetime='-'
                  ele.oiltype ==1 ?ele.oiltypeWord = '正常' :ele.oiltype == 2 ?ele.oiltypeWord = '异常':ele.oiltypeWord = '未知'
                  ele.oilCountAbnormal ==1 ?ele.oilCountAbnormalWord = '正常' :ele.oilCountAbnormal == 2 ?ele.oilCountAbnormalWord = '异常':ele.oilCountAbnormalWord = '-'
                  ele.litterAbnormal == 1 ?ele.litterAbnormalWord = '正常' :ele.litterAbnormal == 2 ?ele.litterAbnormalWord = '异常':ele.litterAbnormalWord = '-'
                })
                this.topSearch = true
            }
          } catch (err) {
            throw new Error(err)
          }
        } else {
          return false;
        }
      });
    },
    handleSizeChange(val) {
          this.ruleForm.pageSize = val
            this.handleSezarch()
    },
    handleCurrentChange(val) {
      return new Promise(async (resolve, reject) => {
        try{
          this.ruleForm.page = val
          let syncTimeStart   = this.ruleForm.date?new Date(this.ruleForm.date[0]).getTime():''
          let syncTimeEnd   = this.ruleForm.date?new Date(this.ruleForm.date[1]).getTime():''
          let cardNo  = this.ruleForm.cardNumber ||''
          let vehicleNo= this.ruleForm.carNumber ||''
          let page = this.ruleForm.page
          let pageSize= this.ruleForm.pageSize

           const response = await this.$store.dispatch('getSingleCardData', { syncTimeStart,syncTimeEnd,cardNo,vehicleNo,page,pageSize })
          this.tableData = response.data.list
          this.totalPages = response.data.count //记录总页
          response.data.list.map((ele,index)=>{
            ele.cardType == 1? ele.cardTypeWord = '主卡' :ele.cardTypeWord = '副卡'
            ele.routeMatch==1? ele.routeMatchWord ='是' : ele.routeMatch==2 ? ele.routeMatchWord ='否' :ele.routeMatch==3? ele.routeMatchWord ='未知' : ele.routeMatchWord ='-'
            ele.opetime?ele.opetime = moment(ele.opetime).format('YYYY-MM-DD HH:mm:ss'):ele.opetime='-'
            ele.oiltype ==1 ?ele.oiltypeWord = '正常' :ele.oiltype == 2 ?ele.oiltypeWord = '异常':ele.oiltypeWord = '未知'
            ele.oilCountAbnormal ==1 ?ele.oilCountAbnormalWord = '正常' :ele.oilCountAbnormal == 2 ?ele.oilCountAbnormalWord = '异常':ele.oilCountAbnormalWord = '-'
            ele.litterAbnormal == 1 ?ele.litterAbnormalWord = '正常' :ele.litterAbnormal == 2 ?ele.litterAbnormalWord = '异常':ele.litterAbnormalWord = '-'
          })
          resolve()
        } catch (err) {
          reject(err)
        }
      })
    },
    exportExcel(){
      let syncTimeStart = this.ruleForm.date ? new Date(this.ruleForm.date[0]).getTime() : ''
        let syncTimeEnd = this.ruleForm.date ? new Date(this.ruleForm.date[1]).getTime() : ''
        let cardNo = this.ruleForm.cardNumber || ''
        let vehicleNo = this.ruleForm.carNumber || ''
        let data = {
          syncTimeStart,
          syncTimeEnd,
          cardNo,
          vehicleNo
        }
        window.location.href='/bi-api/abnormal/exportAbnormalSingle?syncTimeStart='+syncTimeStart+'&syncTimeEnd='+syncTimeEnd
        +'&cardNo='+cardNo+'&vehicleNo='+vehicleNo
    }
  }
}
</script>

<style lang="stylus" scoped>

.flex-center
  display flex
  justify-content center
  align-items center

box-style(bg)
  width 100%
  height 130px
  background white
  display flex
  margin-top 15px
  .leftPart
    background bg
    width 130px
    @extend .flex-center
  .rightPart
    flex 1
    color #99a9c0
    @extend .flex-center
    flex-direction column
    .number
      font-size 30px
      padding-bottom 6px
    .font-center
      text-align center

.dashboard-row
  width 100%
  height 400px
  margin-top 15px
  background white

.dashboard-wrap
  margin-top: -15px
  .box1
    box-style(#41b883)
  .box2
    box-style(#9ab7e0)
  .box3
    box-style(#f7c94d)
  .box4
    box-style(#e45f5f)
  .block
    margin-top:20px
    .pagination
      text-align center
  .line-chart
    @extend .dashboard-row
    padding 15px
    box-sizing border-box

  .todo-wrap
    @extend .dashboard-row
    .todo-header
      span
        font-weight bold
        color #6fb998
      .enterTodo
        float right
        width 140px
        position relative
        top -8px
        right -11px
    .todo-list
      div:not(:first-child)
        margin-top 15px
  
  .system-report
    @extend .dashboard-row
    height 520px
    .report-header
      span
        font-weight bold
        color #6fb998
    .report-content
      .el-alert:not(:first-child)
        margin-top 15px
      .progress-wrap
        margin-top 20px
        text-align center
        padding 20px
        .el-progress:not(:first-child)
          margin-left 20px
          
  .pie-wrap
    @extend .dashboard-row
    height 100%
  .search
    height 500px 
    position relative
    .form
      position absolute 
      top 50%
      left 50%
      transform translate(-50%,-50%)

</style>
